import SwiperInstance from '@/components/customs/swiper-instance'
import SwiperInstanceComponent from 'customs/swiper-instance-component'
import { useEffect, useRef, useState } from 'preact/hooks'
import Icon from 'snippets/icon/icon'
import { getImageBrightness } from '../../utils/image-brightness'

export default function CarouselSwiper({
  children,
  classWrapper,
  className,
  classNavigation = '',
  selector,
  options,
  navigation = false,
  pagination = false,
  scrollbar = true,
  keyboard = false,
  thumbnail = null,
  zoom = false,
  mousewheel = false,
  freeMode = false,
  draggable = false,
  isProductSlide = true,
  template = '',
  attribute,
  classScrollbar,
  setCarouselInstance = () => { },
  isFirstProduct = false,
  onBrightnessChange = () => { }
}) {
  const config = { navigation, pagination, scrollbar, keyboard, thumbnail, zoom, mousewheel, freeMode, draggable }
  const swiperRef = useRef(null)
  const [instance, setInstance] = useState(null)
  const [currentImageBrightness, setCurrentImageBrightness] = useState('light')

  useEffect(() => {
    onBrightnessChange(currentImageBrightness)
  }, [currentImageBrightness, onBrightnessChange])


  const optionDefault = {
    on: {
      init: () => {
        swiperRef.current?.classList.add('swiper-initialized')
      }
    }
  }

  useEffect(() => {
    const currentOptions = {
      ...options,
      ...optionDefault,
      on: {
        ...options.on,
        ...optionDefault.on
      }
    }

    if (isProductSlide) {
      const carouselInstance = new SwiperInstanceComponent(swiperRef.current, currentOptions, config, 'component')

      setInstance(carouselInstance)
      setCarouselInstance(carouselInstance.swiper.swiper)

      if (carouselInstance.swiper?.swiper && pagination) {
        carouselInstance.swiper.swiper.on('slideChange', () => {
          const currentSlide = carouselInstance.swiper.swiper.slides[carouselInstance.swiper.swiper.activeIndex]
          const img = currentSlide?.querySelector('img')

          if (img && img.src) {
            getImageBrightness(img.src).then(brightness => {
              setCurrentImageBrightness(brightness)
            })
          }
        })
      }

      const isMobileDevice = window.innerWidth <= 768

      if (carouselInstance.swiper?.swiper && isFirstProduct && isMobileDevice) {
        const slideCount = carouselInstance.swiper.swiper.slides.length

        if (slideCount > 1) {
          setTimeout(() => {
            if (carouselInstance.swiper?.swiper) {
              const swiper = carouselInstance.swiper.swiper

              const currentTranslate = swiper.translate
              const slideWidth = swiper.slides[0].offsetWidth
              const partialMove = slideWidth * 0.7

              swiper.wrapperEl.style.transition = 'transform 400ms ease-out'
              swiper.setTranslate(currentTranslate - partialMove)

              setTimeout(() => {
                if (swiper && !swiper.destroyed) {
                  swiper.wrapperEl.style.transition = 'transform 400ms ease-out'
                  swiper.setTranslate(currentTranslate)

                  setTimeout(() => {
                    if (swiper.wrapperEl) {
                      swiper.wrapperEl.style.transition = ''
                    }
                  }, 400)
                }
              }, 800)
            }
          }, 1500)
        }
      }
    } else {
      const carouselInstance = new SwiperInstance(swiperRef.current, currentOptions, config)

      setInstance(carouselInstance)

      if (carouselInstance.swiper?.swiper && pagination) {
        carouselInstance.swiper.swiper.on('slideChange', () => {
          const currentSlide = carouselInstance.swiper.swiper.slides[carouselInstance.swiper.swiper.activeIndex]
          const img = currentSlide?.querySelector('img')

          if (img && img.src) {
            getImageBrightness(img.src).then(brightness => {
              setCurrentImageBrightness(brightness)
            })
          }
        })
      }

      const isMobileDevice = window.innerWidth <= 768

      if (carouselInstance.swiper?.swiper && isFirstProduct && isMobileDevice) {
        const slideCount = carouselInstance.swiper.swiper.slides.length

        if (slideCount > 1) {
          setTimeout(() => {
            if (carouselInstance.swiper?.swiper) {
              const swiper = carouselInstance.swiper.swiper

              const currentTranslate = swiper.translate
              const slideWidth = swiper.slides[0].offsetWidth
              const partialMove = slideWidth * 0.7

              swiper.wrapperEl.style.transition = 'transform 400ms ease-out'
              swiper.setTranslate(currentTranslate - partialMove)

              setTimeout(() => {
                if (swiper && !swiper.destroyed) {
                  swiper.wrapperEl.style.transition = 'transform 400ms ease-out'
                  swiper.setTranslate(currentTranslate)

                  setTimeout(() => {
                    if (swiper.wrapperEl) {
                      swiper.wrapperEl.style.transition = ''
                    }
                  }, 400)
                }
              }, 800)
            }
          }, 1500)
        }
      }
    }
  }, [])

  return (
    children && (
      <div className={`swiper-wrapper h-full ${classWrapper}`} ref={swiperRef} data-selector={selector} data-type='component' data-template={template}>
        {navigation && (
          <div className={`swiper-navigation ${classNavigation}`}>
            <button
              className='swiper-button-prev js-carousel-prev'
              type='button'
              aria-label='Previous slide'
            >
              <Icon name='icon-chevron-left-small' className='h-4 w-4' viewBox='0 0 16 16' />
            </button>
            <button
              className='swiper-button-next js-carousel-next'
              type='button'
              aria-label='Next slide'
            >
              <Icon name='icon-chevron-right-small' className='h-4 w-4' viewBox='0 0 16 16' />
            </button>
          </div>
        )}
        <swiper-container className={`swiper ${className} ${selector}`} init='false'>
          {children}
        </swiper-container>
        {pagination && (
          <div class={'swiper-pagination js-carousel-pagination'} />
        )}
        {scrollbar && <div {...attribute} class={`swiper-scrollbar js-carousel-scrollbar ${classScrollbar}`} />}
      </div>
    )
  )
}
